// extracted by mini-css-extract-plugin
export var caractere = "author-quote-module--caractere--70951";
export var content = "author-quote-module--content--c2ead";
export var detailContainer = "author-quote-module--detailContainer--1a32c";
export var detailText = "author-quote-module--detailText--77ea0";
export var image = "author-quote-module--image--e644a";
export var imageContainerLeft = "author-quote-module--imageContainerLeft--e6ee0";
export var imageContainerRight = "author-quote-module--imageContainerRight--a0657";
export var jobPosition = "author-quote-module--jobPosition--10321";
export var jobPositionDetail = "author-quote-module--jobPositionDetail--3afaa";
export var name = "author-quote-module--name--91ba8";
export var root = "author-quote-module--root--2a584";